var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"expand":""}},[_c('v-list-tile',{attrs:{"value":true,"to":{name:'NewMapLayer'}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("mdi-map")])],1),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('Configuration.MapLayers')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }